export function programTabsBlock() {
    const block = document.querySelector(".sbm-program-tabs-block");
    if (!block) return;
    
    const tabs = document.querySelectorAll(".sbm-program-tabs-block__tab");
    const mobileTabs = document.querySelectorAll(
        ".sbm-program-tabs-block__menu-mobile--tabs .custom-select__item"
    );
    
    tabs.forEach((tab) => {
        tab.addEventListener("click", (event) => tabClick(event));
    });
    mobileTabs.forEach((mobileTab) => {
        mobileTab.addEventListener("click", (event) => tabClick(event));
    });
    
    function tabClick(event) {
        const tab = event.target;
        if (tab.classList.contains("active")) return;
        
        const tabID = tab.getAttribute("ref");
        const item = block.querySelector(`.sbm-program-tabs-item__item[ref="${tabID}"]`
        );
        
        resetTabs();
        tab.classList.add("active");
        item.classList.add("active");
    }
    
    function resetTabs() {
        const tabs = block.querySelectorAll(
            ".sbm-program-tabs-block__tab, .sbm-program-tabs-block__menu-mobile--tabs .custom-select__item, .sbm-program-tabs-block__menu-mobile--tabs .custom-select__selected"
        );
        const items = block.querySelectorAll(".sbm-program-tabs-item__item");
        tabs.forEach((tab) => tab.classList.remove("active"));
        items.forEach((item) => item.classList.remove("active"));
    }
}
